import { DrawerHeaderButton } from 'design-system';
import { ArrowLeft, X } from 'lucide-react';

import { useDrawerSteps } from '@/features/dashboard/components/Drawer/context/DrawerStepsContext';
import { DrawerHeader } from '@/features/dashboard/components/Drawer/DrawerHeader';

import { useSaveApp } from './useSaveApp';

const AddAppHeader = () => {
  const { handleAttemptBack, isEditMode, handleAttemptClose } = useDrawerSteps();
  const { isPending } = useSaveApp();

  return (
    <DrawerHeader
      before={
        <DrawerHeaderButton
          disabled={isPending}
          label='Go back'
          onClick={handleAttemptBack}
        >
          <ArrowLeft />
        </DrawerHeaderButton>
      }
      buttons={
        <DrawerHeaderButton
          disabled={isPending}
          label='Discard'
          onClick={() => {
            if (!isPending) {
              handleAttemptClose();
            }
          }}
        >
          <X />
        </DrawerHeaderButton>
      }
      title={isEditMode ? 'Edit app' : 'Add new app'}
    />
  );
};

export default AddAppHeader;
